module.exports = "<p>report-pre works!</p>\n"